'use client';

import { ChevronDownIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import * as React from 'react';

import { cn } from '@heidi/utils';

import type { CalendarChevronProps } from './calendar.types';

/**
 * Month-nav chevron for the `Calendar` component (passed as DayPicker's
 * `components.Chevron`).
 *
 * The prev/next arrows are directional, so they mirror in RTL (`rtl:-scale-x-100`)
 * to point outward (< far-start, > far-end). The down chevron (dropdowns) is not
 * directional and must not flip.
 */
const CalendarChevron = React.forwardRef<SVGSVGElement, CalendarChevronProps>(
  function CalendarChevron(
    { className, orientation, 'data-testid': testId, ...props },
    ref
  ) {
    if (orientation === 'left') {
      return (
        <ChevronLeftIcon
          ref={ref}
          data-testid={testId}
          className={cn('size-4 rtl:-scale-x-100', className)}
          {...props}
        />
      );
    }

    if (orientation === 'right') {
      return (
        <ChevronRightIcon
          ref={ref}
          data-testid={testId}
          className={cn('size-4 rtl:-scale-x-100', className)}
          {...props}
        />
      );
    }

    return (
      <ChevronDownIcon
        ref={ref}
        data-testid={testId}
        className={cn('size-4', className)}
        {...props}
      />
    );
  }
);
CalendarChevron.displayName = 'CalendarChevron';

export { CalendarChevron };
